<template>
  <v-list subheader dense class="pb-0" :width="'100%'">
    <v-list-item v-if="!layers || !layers.length" dense class="pl-8" :width="'100%'">
      <v-checkbox
        v-if="multiple"
        hide-details
        dense
        :value="state.checkbox"
        :indeterminate="state.checkbox === '-'"
        class="pl-10"
        @click.stop="$_onClick"
      >
        <span
          slot="label" class="textPrimary--text"
        ><slot></slot></span>
      </v-checkbox>
      <v-radio-group
        v-model="state.radio"
        hide-details
        dense
        class="mt-0"
      >
        <v-radio
          v-if="!multiple"
          value="radio"
          @change="$_onClick"
        >
          <span
            slot="label" class="textPrimary--text ml-2"
          ><slot></slot></span>
        </v-radio>
      </v-radio-group>
    </v-list-item>
    <v-list-group
      v-if="layers&&layers.length"
      sub-group
      dense
      class="pl-0"
      no-action
      @click.stop.prevent="$_onClickItem"
    >
      <template v-slot:prependIcon>
        <v-icon right>{{_menuIcon}}</v-icon>
      </template>
      <template v-slot:activator>
        <v-list-item-content>
          <v-checkbox
            v-if="multiple"
            hide-details
            dense
            :value="state.checkbox"
            :indeterminate="state.checkbox === '-'"
            class="ma-0 pl-0"
            @click.stop="$_onClick"
          >
            <span
              slot="label" class="textPrimary--text"
            ><slot></slot></span>
          </v-checkbox>
          <span 
            v-if="!multiple"
            class="textPrimary--text"
          ><slot></slot></span>
        </v-list-item-content>
      </template>
      <v-list-item
        v-for="(item,itemIndex) in layers"
        :key="itemIndex"
        class="pl-2"
        dense
        @click.stop.prevent="$_onRemoveDefaultClickEvent()"
      >
        <WsStateMultiLayerLayers
          :layers="item.layers"
          :valueKey="valueKey"
          :textKey="textKey"
          :multiple="multiple"
          :active="$_getStatus(value, layers, item)"
          :value="$_getItemsValue(value, item[`${valueKey}`])"
          @click-checkbox="$_onClickCheckbox($event, value, layers, item)"
          @input="$_onItemInput($event, value, item)"
        >{{item[`${textKey}`]}}</WsStateMultiLayerLayers>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  data() {
    return {
      itemsActive: false,
      state: {
        checkbox: null,
        radio: null,
      }
    }
  },
  props: {
    active: {
      type: [Boolean, String],
      default: false,
    },
    layers: {
      type: Array
    },
    value: {},
    textKey: {
      type: String,
      default: "name",
    },
    valueKey: {
      type: String,
      default: "id",
    },
     multiple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_onRemoveDefaultClickEvent(){
      return null
    },
    $_onClick(){
      this.$emit('click-checkbox')
    },
    $_getItemsValue(value, itemId) {
      if (!value) {
        return;
      }
      const targetValue = value.find((e) => {
        return e[`${this.valueKey}`] == itemId;
      });
      if (!targetValue) {
        return;
      }
      return targetValue.layers;
    },
    $_onClickItem(){
      this.itemsActive = !this.itemsActive
    },
    $_onClickCheckbox($event, value, layers, item) {
      let _value = []
      if (this.multiple) {
        _value = value ? [...value] : []
      }
      const status = this.$_getStatus(value, layers, item)
      const targetIndex = _value.findIndex((e) => {
        return e[`${this.valueKey}`] === item[`${this.valueKey}`]
      })
      const fullValue = this.$_getFullValueFromItemValue(item);
      if (status === true) {
        _value.splice(targetIndex, 1);
      } else if (status == "-") {
        _value.splice(targetIndex, 1);
      } else {
        if (targetIndex >= 0) {
          _value.splice(targetIndex, 1);
        } else {
          _value.push(fullValue);
        }
      }
      this.$emit("input", _value);
    },
    $_getStatus(value, layers, item) {
      if (!value) return false
      const targetValue = value.find((e) => {
        return e[`${this.valueKey}`] === item[`${this.valueKey}`];
      });
      if (!targetValue) {
        return false
      }
      if (targetValue && layers) {
        const targetItem = layers.find((e) => {
          return e[`${this.valueKey}`] === item[`${this.valueKey}`];
        })
        if (targetItem.layers) {
          if (targetValue.layers && targetValue.layers.length) {
            let allOk = 1;
            let hasOk = 0;
            targetItem.layers.forEach((item) => {
              if (
                this.$_getStatus(
                  targetValue.layers,
                  targetItem.layers,
                  item
                ) === true
              ) {
                hasOk = 1
              } else if (
                this.$_getStatus(
                  targetValue.layers,
                  targetItem.layers,
                  item
                ) === false
              ) {
                allOk = 0
              } else {
                allOk = 0
                hasOk = 1
              }
            });
            if (allOk) {
              return true;
            } else {
              if (hasOk) {
                return "-";
              } else {
                return false;
              }
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    $_getFullValueFromItemValue(item) {
      const _fullValue = {
        [`${this.valueKey}`]: item[`${this.valueKey}`],
        [`${this.textKey}`]: item[`${this.textKey}`],
        layers: [],
      };
      return _fullValue;
    },
    $_onItemInput($event, value, item) {
      if (this.multiple) {
        let _value = value ? [...value] : [];
        const targetValueIndex = _value.findIndex((e) => {
            return e[`${this.valueKey}`] == item[`${this.valueKey}`];
        });
        if (targetValueIndex < 0) {
          _value.push({
            [`${this.valueKey}`]: item[`${this.valueKey}`],
            [`${this.textKey}`]: item[`${this.textKey}`],
            layers: [],
          });
        }
        const targetValue = _value.find((e) => {
            return e[`${this.valueKey}`] == item[`${this.valueKey}`];
        });
        if (!$event  || !$event.length) {
          targetValue.layers = [];
        } else {
          targetValue.layers = $event;
        }
        this.$emit("input", _value);
      } else {
        let _value = [{
          [`${this.valueKey}`]: item[`${this.valueKey}`],
          [`${this.textKey}`]: item[`${this.textKey}`],
          layers: [],
        }];
        if (!$event  || !$event.length) {
          _value[0].layers = [];
        } else {
          _value[0].layers = $event;
        }
        this.$emit("input", _value);
      }
    },
  },
  computed: {
    _menuIcon() {
      if (this.layers && this.layers.length > 0) {
        return "mdi-menu-down"
      } else {
        return null
      }
    },
  },
  watch: {
    active() {
      if (this.multiple) {
        this.state.checkbox = this.active
      } else {
        this.state.radio = this.active === true
        ? "radio"
        : null
      }
    }
  },
  mounted() {
    this.state.checkbox = this.active
  }
}
</script>